/**
 * Conversation Subscription
 *
 * Browser Supabase realtime is disabled because auth is server-side and cookies
 * are HttpOnly. Conversation updates are refreshed through authenticated APIs.
 */

export interface ConversationSubscriptionCallbacks {
  onConversationUpdate?: () => void;
}

export interface ConversationSubscriptionConfig {
  userId: string;
  callbacks: ConversationSubscriptionCallbacks;
  enabled?: boolean;
}

export class ConversationSubscription {
  constructor(_config: ConversationSubscriptionConfig) {
    void _config;
  }

  subscribe(): void {
    // Server-side auth intentionally disables browser Supabase realtime.
  }

  cleanup(): void {
    // No browser channel to clean up.
  }
}
